export const columns = [
    {
        id: 'country',
        label: 'Country'
    },
    {
        id: 'mufti',
        label: 'Mufti'
    },
    {
        id: 'website',
        label: 'Website',
    },
];

export const rows = [
    {
        country: 'Australia',
        mufti: 'MUFTI FAIZAL RIZA',
        website: 'www.fatwa.org.au'
    },
    {
        country: 'United Kingdom',
        mufti: 'MUFTI FARAZ ADAM',
        website: 'www.darulfiqh.com'
    },
    {
        country: '',
        mufti: 'MUFTI HANIF PATEL',
        website: 'www.askourimam.com'
    },
    {
        country: '',
        mufti: 'MUFTI LUQMAN HANSROT',
        website: 'www.efiqh.com'
    },
    {
        country: '',
        mufti: 'MUFTI ZAMEELUR RAHMAN',
        website: 'www.darulmaarif.com'
    },
    {
        country: '',
        mufti: 'MUFTI BILAL ISSAK',
        website: 'www.markazulfiqh.com'
    },
    {
        country: 'Canada',
        mufti: 'MUFTI FAISAL NIAZI',
        website: 'www.fatwa.ca'
    },
    {
        country: '',
        mufti: 'MUFTI ZAIN MIRZA AND MUFTI HAMMAD JOGIAT',
        website: 'www.cciri.ca'
    },
    {
        country: 'USA',
        mufti: 'MUFTI ABDUL AZEEM',
        website: 'www.masjidyaseen.org'
    },
    {
        country: '',
        mufti: 'MUFTI MUAJUL I CHOWDHURY',
        website: 'www.askthemufti.us'
    },
    {
        country: 'South Africa',
        mufti: 'MUFTI ISMAIL/ISHAAQ MOOSA',
        website: 'www.fatwaa.com'
    },
    {
        country: '',
        mufti: 'MUFTI ISMAEEL BASSA',
        website: 'www.themufti.com'
    },
    {
        country: 'Mozambique',
        mufti: 'MUFTI MAHOMMAD YASSER',
        website: 'www.daruliftaamahmudiyyah.co.mz'
    },
    {
        country: '',
        mufti: 'MUFTI HUSSEIN ISSA',
        website: 'www.daruliftaummati.co.mz'
    },
    {
        country: 'Russia',
        mufti: 'MUFTI SOHAIL',
        website: 'www.askimam.ru'
    },
    {
        country: 'Malawi',
        mufti: 'MUFTI SAFWAAN IBRAHIM',
        website: 'www.daruliftaamw.com'
    },
    {
        country: 'Zambia',
        mufti: 'PANEL OF MUFTIS',
        website: 'www.daruliftaazambia.com'
    },
    {
        country: 'Mauritius',
        mufti: 'MUFTI MUHAMMAD ASHHAD',
        website: 'www.askmufti.net'
    },
    {
        country: 'Trinidad',
        mufti: 'MUFTI ARSHAD ALI',
        website: 'www.fatwa-tt.com'
    },
    {
        country: 'Jamaica',
        mufti: 'MUFTI SAEED AHMED GOLAUB',
        website: 'www.islamicsolutions.org'
    },
];
